export const VUEX_SEASONS_FETCH = 'VUEX_SEASONS_FETCH'
export const VUEX_SEASONS_REFETCH = 'VUEX_SEASONS_REFETCH'
export const VUEX_SEASON_FETCH = 'VUEX_SEASON_FETCH'
export const VUEX_SEASON_UPDATE = 'VUEX_SEASON_UPDATE'
export const VUEX_SEASON_DELETE = 'VUEX_SEASON_DELETE'
export const VUEX_SEASON_CREATE = 'VUEX_SEASON_CREATE'
export const VUEX_SEASON_SET_UPDATE_STATE = 'VUEX_SEASON_SET_UPDATE_STATE'
